import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Table, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner'
import { GET_PROFILER_RUNS_QUERY, DELETE_PROFILER_RUN_MUTATION } from '../../../graphql.js'
import { handleGraphQLErrors, publishEvent } from '../../../utils'

export const GET_PROFILER_RUNS = gql(GET_PROFILER_RUNS_QUERY)
export const DELETE_PROFILER_RUN = gql(DELETE_PROFILER_RUN_MUTATION)

export default function ProfilerRuns(props) {
  console.log('ProfilerRuns rendered')

  const [spinner, setSpinner] = useState(false)
  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function deleteRun(runId) {
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.mutate({ mutation: DELETE_PROFILER_RUN, variables: { runId: runId } })
      console.log('DELETE PROFILE RUN data: ', { data })
      setItems([])
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    } finally {
      setSpinner(false)
    }
  }

  async function selectRun(runId) {
    publishEvent('PROFILER RUN SELECTED', runId, 'ProfilerRuns.selectRun')
  }

  useEffect(() => {
    async function fetchItems() {
      try {
        setSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: GET_PROFILER_RUNS })
        console.log('GET_PROFILER_RUNS data: ', { data })
        if (data.getProfilerRuns) {
          const runs = []
          for (let run of data.getProfilerRuns) {
            runs.push(
              <tr key={run.id}>
                <td>{run.id}</td>
                <td>{run.date}</td>
                <td style={{ textAlign: 'right' }}>{run.totalTime}</td>
                <td><Button size="sm" color="primary" onClick={(e) => selectRun(run.id)}>View</Button></td>
                <td><Button size="sm" color="danger" onClick={(e) => deleteRun(run.id)}>Delete</Button></td>
              </tr>)
          }
          setItems(runs)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
    if (!items) {
      fetchItems()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }
  return (
    <div style={{ marginTop: '20px' }}>
      <Table bordered style={{ padding: '.25rem', width: 'auto', margin: 'auto' }}>
        <thead>
          <tr><td colSpan={5}>Profiler Runs</td></tr>
          <tr>
            <th>Run ID</th>
            <th>Date</th>
            <th>Total Time</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </Table>
    </div>
  )
}
